import Vue from 'vue';
import Vuex from 'vuex';
import { state } from './state';
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { plugins } from './plugins';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  plugins: [plugins]
});



// WEBPACK FOOTER //
// ./src/store/storeMain.js